<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="charts-section">
	@if (authorizationService.canSee(grants.environmentalImpactApplications)) {
		@let worst10Applications = worst10Applications$ | async;
		<div class="chart-panel">
			<globalictcc-chart
				#worst10ApplicationsChart
				chartType="barY"
				[data]="worst10Applications?.data?.chart"
				[isLoading]="worst10Applications?.isLoading ?? true"
				[hasError]="worst10Applications?.hasError || worst10Applications?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10ApplicationsChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							worst10ApplicationsChart.instance,
							'cloud_worst_10_applications'
						)
					"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.environmentalImpactRegions)) {
		@let worst10Locations = worst10Locations$ | async;
		<div class="chart-panel">
			<globalictcc-chart
				#worst10LocationsChart
				chartType="barY"
				[data]="worst10Locations?.data?.chart"
				[isLoading]="worst10Locations?.isLoading ?? true"
				[hasError]="worst10Locations?.hasError || worst10Locations?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10LocationsChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(worst10LocationsChart.instance, 'cloud_worst_10_locations')
					"
				/>
			</div>
		</div>
	}
</div>
